import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import WeekText from "../../Main/Prevention/Week/WeekText.js";
// import useSEO from "../../../hooks/useSEO.js";
// import seoConfig from "../../../hooks/seoConfig.js";

import data from "../../Data/patents/patents.json";

export default function Patents() {
  // useSEO(seoConfig.week);

  return (
    <section className="structure">
      <Breadcrumbs />

      <h1 className="weekpage__title">Патенты ГБУ СО «УрНИИДВиИ»</h1>
      <div>
        <WeekText data={data} />
      </div>
    </section>
  );
}
